import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { BellRing, FolderCheckIcon, FolderXIcon, FoldersIcon, LogOut, Settings, User } from 'lucide-react'

import { LOCAL_STORAGE_KEY_MAP } from '@/lib/constants/platform'
import { getUserQuery } from '@/lib/queries/business/v2/user/queries'
import { cn } from '@/lib/utils'

import { AddApplicant } from './add-applicant/add-applicant'
import { SideBarItemGroup } from './side-bar-item-group/side-bar-item-group'
import { SidebarItem } from './side-bar-item/side-bar-item'
import { ViewPlan } from './view-plan/view-plan'

export const Sidebar: React.FC = () => {
  const { data: dataUser } = useQuery(getUserQuery)

  return (
    <aside className={cn('relative flex h-full flex-col items-start px-0 pb-7 pt-8')}>
      <div className={cn('flex flex-col gap-2', 'mb-8 px-3')}>
        <AddApplicant />
      </div>

      <div className={cn('flex w-full flex-1 flex-col')}>
        <div className={cn('border-b pb-6')}>
          <div className={cn('mb-4 px-3')}>
            <Link to={'/updates'} search={{ page: 1 }}>
              {({ isActive }) => <SidebarItem icon={<BellRing size={16} />} text="Dashboard" isActive={isActive} />}
            </Link>
          </div>

          <div className={cn('mb-2 px-7 text-lg font-semibold')}>List</div>
          <div className={cn('flex flex-col space-y-1 px-3')}>
            <Link
              to={'/applicants'}
              activeOptions={{ includeSearch: false }}
              search={{
                page: 1,
                sortKey: 'id',
                sortOrder: 'desc',
              }}
            >
              {({ isActive }) => <SidebarItem icon={<User size={16} />} text="Applicants" isActive={isActive} />}
            </Link>

            <SideBarItemGroup
              icon={<FoldersIcon size={16} />}
              label="Cases"
              matchingPaths={['/cases/active', '/cases/inactive']}
            >
              <Link
                to={'/cases/active'}
                activeOptions={{ includeSearch: false }}
                search={{
                  page: 1,
                }}
              >
                {({ isActive }) => (
                  <SidebarItem icon={<FolderCheckIcon size={16} />} text="Active Cases" isActive={isActive} />
                )}
              </Link>
              <Link
                to={'/cases/inactive'}
                activeOptions={{ includeSearch: false }}
                search={{
                  page: 1,
                }}
              >
                {({ isActive }) => (
                  <SidebarItem icon={<FolderXIcon size={16} />} text="Inactive Cases" isActive={isActive} />
                )}
              </Link>
            </SideBarItemGroup>
          </div>
        </div>
      </div>

      <div className={cn('flex-0 mb-16 flex w-full flex-col gap-1 px-3')}>
        <Link to={'/settings'}>
          {({ isActive }) => <SidebarItem icon={<Settings size={16} />} text="Settings" isActive={isActive} />}
        </Link>

        <SidebarItem
          icon={<LogOut size={16} />}
          text="Log out"
          asChild={false}
          onClick={() => {
            localStorage.removeItem(LOCAL_STORAGE_KEY_MAP.token)
            window.location.href = '/'
          }}
        />
      </div>

      {dataUser && !dataUser.subscription && (
        <div className="px-3">
          <ViewPlan />
        </div>
      )}
    </aside>
  )
}
